var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeciality4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:none;stroke:#208ce1;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.d{fill:#cee1ff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-2861 -3943)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(2861 3943)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2859.414 -3941.568)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M77.084,30.815a47.777,47.777,0,0,0,11.327,0s.746-.078,2.005-.237",
    transform: "translate(-54.412 -21.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M57.8,19.054S55.928,9.042,61.555,4.092V.989",
    transform: "translate(-40.628 -0.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M83.039.989v2.8s4.494.6,4.494,6.523",
    transform: "translate(-58.603 -0.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M62.842,29.924c-1.194.158-2.044.256-2.044.256-3.123.273-5.5.362-5.5.362a17.655,17.655,0,0,0,.929,6.256.055.055,0,0,0,.03.028,11.284,11.284,0,0,1,6.4,7.013,25.913,25.913,0,0,1,.612,8.229,20.783,20.783,0,0,1-1.545,6.119,16.987,16.987,0,0,1-1.4,2.741,4.855,4.855,0,0,1-4.95,2.14c-6.269-1.115-12.53-7.178-12.53-7.178a21.049,21.049,0,0,1-3.535-4.6,11.591,11.591,0,0,1,2.3-14l1.612-1.515a7.289,7.289,0,0,1,6.7-1.79l.041.011a9.7,9.7,0,0,0,1.263-3.719s-.391-.041-.9-.122a1.949,1.949,0,0,1-1.634-2.179,9.821,9.821,0,0,1,1.7-4.145",
    transform: "translate(-26.838 -16.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M26.585,42.445c-7.643-6.807-4.038-12.543-3.018-13.871a13.555,13.555,0,0,0,.809-1.141,13.5,13.5,0,0,0,1.9-8.483",
    transform: "translate(-15.514 -13.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M50.1,18.95s-.779,5.425,2.281,6.237",
    transform: "translate(-35.357 -13.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M72.485,58.152s-5.364,8.465-.616,13.879",
    transform: "translate(-49.359 -40.697)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M28.442,61.842c.3.28,5.985,5.631,11.4,6.595a2.861,2.861,0,0,0,.49.043,2.708,2.708,0,0,0,2.279-1.233,14.731,14.731,0,0,0,1.217-2.389,20.055,20.055,0,0,0,1.4-5.531,17.444,17.444,0,0,1-1.211,2.081,7.351,7.351,0,0,1-9.04,2.441,24.583,24.583,0,0,1-10.735-9.275,9.078,9.078,0,0,0,1.046,3.157,18.958,18.958,0,0,0,3.164,4.11",
    transform: "translate(-10.924 -24.023)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality4);
export default __webpack_public_path__ + "static/media/speciality4.54bfdf137776f1a73ce78a9d81136e57.svg";
export { ForwardRef as ReactComponent };